<!DOCTYPE html>
<template>
<div class="form-input">

  <div v-if="!active"
       class="fake"
       @click="activate">

    <div class="label">{{field.label}}</div>

    <div class="value">
      <div v-if="field.type=='boolean'"
           class="boolean">
        {{displayValue === true ? 'True' : 'False'}}
      </div>

      <div v-else-if="field.type=='multi_select'"
           class="options">
        <template v-if="displayValue">
          <b-badge pill
                   variant="primary"
                   v-for="option in displayValue"
                   :key="option.id">{{option.text}}</b-badge>
        </template>
      </div>

      <div v-else-if="field.type=='single_select' && field.reference && displayValue">
        {{dotExpand(displayValue, field.text_field)}}
      </div>

      <div v-else-if="field.type=='single_select' && !field.reference">
        {{displayValue}}
      </div>

      <div v-else-if="displayValue">
        {{displayValue}}
      </div>

      <div v-else>
        ---
      </div>
    </div>

  </div>


  <div class="real shadow"
       v-else>

    <h5 class="label">{{field.label}}</h5>


    <div class="inputs">
      <b-form-input v-if="field.type == 'text' || field.type =='number'"
                    v-model="value"
                    autocomplete="off"
                    variant="success"
                    :number="field.type=='number'"
                    :type="field.type"></b-form-input>


      <b-form-checkbox v-if="field.type == 'boolean'"
                       switch
                       v-model="value">
        {{value}}
      </b-form-checkbox>


      <b-form-checkbox-group v-if="field.type == 'multi_select'"
                             v-model="innerValue"
                             :options="allOptions"
                             value-field="path">
      </b-form-checkbox-group>


      <b-form-select v-if="field.type == 'single_select' && field.reference"
                     v-model="innerValue"
                     :options="allOptions"
                     :text-field="field.text_field ? field.text_field : 'name'"
                     value-field="path">
      </b-form-select>


      <b-form-select v-if="field.type == 'single_select' && !field.reference"
                     v-model="value"
                     :options="allOptions">
      </b-form-select>


    </div>
    <div class="actions">
      <b-spinner v-if="saving"
                 label="Loading..."></b-spinner>

      <b-button @click="save"
                v-if="!saving"
                variant="success">Save</b-button>
      <b-button @click="cancel"
                v-if="!saving"
                variant="outline-light">Cancel</b-button>
    </div>

  </div>

</div>
</template>

<script>
const firebase = require( '../../firebaseConfig.js' )

export default {
  name: 'FormInput',
  components: {},
  props: {
    field: Object,
    item: Object,
    section: Object,
  },
  mounted() {
    if ( typeof this.field.options == 'object' && this.field.reference ) {
      this.$bind( 'allOptions', this.field.options )
    } else if ( this.field.options ) {
      this.allOptions = this.field.options
    }
    this.loadValues()
  },
  data() {
    return {
      active: false,
      value: null,
      innerValue: null,
      allOptions: null,
      saving: false,
    }
  },
  computed: {
    displayValue() {
      let base = this.dotExpand( this.item, this.field.path )
      if ( !base ) {
        return '—'
      }
      return base
    }
  },
  methods: {
    activate() {
      if ( this.field.readOnly ) {
        return
      }
      this.active = true
      this.loadValues()
    },
    cancel() {
      this.loadValues()
      this.close()
    },
    close() {
      this.active = false
    },
    save() {
      this.saving = true
      let obj = {}
      if ( this.field.reference && this.field.type == "multi_select" ) {
        // If this is an array of reference values
        this.value = this.innerValue.map( a => {
          return this.allOptions.find( b => a == b.path )
        } ).map( c => c.path )
        obj[ this.field.path ] = this.convertToReferenceArray()
      } else if ( this.field.reference && this.field.type == "single_select" ) {
        // If this is a single reference value
        this.value = this.innerValue
        obj[ this.field.path ] = this.convertToReference()
      } else {
        // If this is a single regular value
        obj[ this.field.path ] = this.value
      }
      firebase.db
        .collection( this.section.db )
        .doc( this.item.id )
        .update( obj )
        .then( () => {
          this.saving = false
          this.close()
        } )
        .catch( function( err ) {
          this.saving = false
          console.log( err )
        } )
    },
    loadValues() {
      if ( this.field.reference && this.field.type == "multi_select" ) {
        // If this is an array of reference values
        this.value = this.dotExpand( this.item, this.field.path )
        if ( this.value ) {
          this.innerValue = this.value.map( i => i.path )
        } else {
          this.innerValue = null
        }
      } else if ( this.field.reference && this.field.type == "single_select" ) {
        // If this is a single reference value
        this.value = this.dotExpand( this.item, this.field.path )
      } else {
        // If this is a single regular value
        this.value = this.dotExpand( this.item, this.field.path )
      }
    },
    convertToReferenceArray() {
      let referencedArray = []
      for ( let i of this.value ) {
        let referencePath = i
        referencedArray.push( firebase.db.doc( referencePath ) )
      }
      return referencedArray
    },
    convertToReference() {
      let referencePath = `${this.value}`
      return firebase.db.doc( referencePath )
    },
    dotExpand( root, path ) {
      let levels = path.split( '.' )
      let tempObject = root
      for ( let level of levels ) {
        if ( tempObject[ level ] ) {
          tempObject = tempObject[ level ]
        } else {
          return null
        }
      }
      return tempObject
    },
  },
}
</script>


<style scoped lang="scss">
@import "@/styles/global.scss";

.form-input {
    border-bottom: 1px solid theme-color-level('primary', -11);

    .fake {
        display: grid;
        grid-column-gap: 1rem;
        grid-template-columns: 8vw 1fr;
        cursor: pointer;
        color: theme-color-level('primary', 6);
        padding: 1rem 3rem;

        &:hover {
            background: theme-color-level('primary', -12);
        }

        .label {
            font-size: 0.9rem;
            align-self: center;
            color: theme-color-level('primary',-3);
        }

        .value {
            display: grid;
            min-height: 1rem;

            .options {
                > * {
                    margin: 0.2rem;
                }
            }
        }

    }
    .real {
        border-radius: 0.5rem;
        padding: 2rem;
        margin: 1rem;
        display: grid;
        align-items: flex-start;
        grid-auto-flow: column;
        grid-template-columns: 8vw 1fr auto;
        grid-column-gap: 1rem;

        .label {
            font-family: 'Futura-X';
        }

        [role="group"] {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            grid-column-gap: 0.2rem;
            grid-row-gap: 0.2rem;
            font-size: 0.8rem;
        }

        .actions {
            display: grid;
            justify-content: flex-end;
            grid-auto-flow: column;
            grid-column-gap: 0.5rem;
        }
    }
}
</style>
